
















import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';
import CommunityGroupCard from '@/web/components/community/CommunityGroupCard';

export default Vue.extend({
  name: 'CommunityGroups',
  components: {
    CommunityGroupCard,
  },
  props: {
    groups: {
      type: Array as () => CommunityGroupsResponse[],
      default: [],
    },
  },
});
